import React from "react";
import Sidebar from "./Sidebar";

export default function Layout({ children }) {
  return (
    <div
      className="crm-page-shell"
      style={{
        display: "grid",
        gridTemplateColumns: "280px minmax(0, 1fr)",
        minHeight: "100vh",
      }}
    >
      <Sidebar />

      <main
        style={{
          minWidth: 0,
          padding: "24px",
        }}
      >
        <div className="crm-content-wrap">{children}</div>
      </main>
    </div>
  );
}
